import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import UploadButtonComponent from "components/common/UploadButton/UploadButtonComponent";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import { acceptableFormats } from "config/constants";
import { IPaiyaUploadsProps } from "./PaiyaUploads.interface";

const PaiyaUploads = (props: IPaiyaUploadsProps) => {
  const {
    giftCsvFileName,
    handleGiftCSVRemove,
    handleGiftCSVInputChange,
    paiyaConfigCreation,
    storeCsvFileName,
    handleStoreCSVRemove,
    handleStoreCSVInputChange,
    isGiftCsvLoading,
    isStoreCsvLoading,
  } = props;

  return (
    <FormSectionLayout subTitleText="Uploads">
      <div className="paiya-upload-component-container-wrapper">
        <Row>
          <Col lg="6">
            <UploadButtonComponent
              id="upload-gift-csv"
              buttonText={
                giftCsvFileName ? giftCsvFileName : "Upload .CSV for gifts"
              }
              fileFormat={acceptableFormats.csv}
              fileUploaded={!!giftCsvFileName}
              handleRemoveFile={handleGiftCSVRemove}
              handleFileChange={handleGiftCSVInputChange}
              classes="large-button btn-primary"
            />
          </Col>
        </Row>
        <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center">
          <span>max 300 lines</span>
          <a
            href={require("../../../../assets/static/giftCsv.csv")}
            target="_blank"
            className=""
          >
            <small>Download Sample </small>
          </a>
        </div>

        <div className="pt-3 pb-1"></div>
        <Row>
          <Col lg="6">
            <UploadButtonComponent
              id="upload-store-csv"
              buttonText={
                storeCsvFileName ? storeCsvFileName : "Upload .CSV for stores"
              }
              fileFormat={acceptableFormats.csv}
              fileUploaded={!!storeCsvFileName}
              handleRemoveFile={handleStoreCSVRemove}
              handleFileChange={handleStoreCSVInputChange}
              classes="large-button btn-primary"
            />
          </Col>
          {/* <Col lg="2">{paiyaConfigCreation.storeCsvFileName}</Col>             */}
        </Row>
        <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center">
          <span>max 5000 lines</span>
          <a
            href={require("../../../../assets/static/storeCsv.csv")}
            target="_blank"
            className=""
          >
            <small>Download Sample </small>
          </a>
        </div>

      </div>
    </FormSectionLayout>
  );
};

export default PaiyaUploads;
